module.exports = function() {
  return new Worker(__webpack_public_path__ + "f4ea50ee76121bcabdb9.worker.js");
};